var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PromotionHeader',{attrs:{"img_header":_vm.header_image,"header":"จัดชุดโปรโมชั่นใหม่","link_back":"stock/promotion_stock/promotionset"}}),_c('Promotion_add')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }